module.exports = "/images/carla.jpg?35a7c71514d6337763123106f9ed27fb";